import { useEffect, useState } from 'react'

/**
 * Hook that tracks whether the browser window/tab is focused.
 * Uses the Page Visibility API to detect when user switches tabs.
 * @returns Boolean indicating if window is currently focused
 */
export const useIsWindowFocused = () => {
  const [isFocused, setIsFocused] = useState(
    () => typeof document !== 'undefined' && document.visibilityState !== 'hidden'
  )
  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setIsFocused(false)
      } else {
        setIsFocused(true)
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return isFocused
}
